<div red-card [attr.redBackground]="redBackground" [attr.redShape]="redShape" [attr.redCol]="redCol">
  <ng-content></ng-content>

</div>